import React, { useMemo, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const DEFAULT_REVIEWS = [
  {
    id: 1,
    name: "Ekram Hossain",
    role: "CEO of Themesvila",
    image:
      "https://storage.googleapis.com/road-to-fe/uploads/1741110068604-0bcf572c-2c60-4ba1-99b0-7e9c6bf71d3a-person1.webp",
    rating: 5.0,
    review:
      "Test Test Test Test Test Test Test Test Test Test Test Test Test  Test Test Test Test Test Test  Test Test",

    // "Donec viverra posuere nibh in dapibus. Pellentesque finibus libero vel tempus.",
  },
  {
    id: 2,
    name: "Motasim Billah",
    role: "CEO of ABC",
    image:
      "https://storage.googleapis.com/road-to-fe/uploads/1741110088710-42ea2000-ded3-4849-976f-243c8ddb523d-person2.webp",
    rating: 5.0,
    review:
      "Test Test Test Test Test Test Test Test Test Test Test Test Test  Test Test Test Test Test Test  Test Test",

    // "Donec viverra posuere nibh in dapibus. Pellentesque finibus libero vel tempus.",
  },
  {
    id: 3,
    name: "Ekram Hossain",
    role: "CEO of Themesvila",
    image:
      "https://storage.googleapis.com/road-to-fe/uploads/1741110092837-af81c820-2ba7-4255-bd8b-ee5acd01ecf1-person3.webp",
    rating: 4.0,
    review:
      "Test Test Test Test Test Test Test Test Test Test Test Test Test  Test Test Test Test Test Test  Test Test",

    // "Donec viverra posuere nibh in dapibus. Pellentesque finibus libero vel tempus.",
  },
];

const ReviewSlider = ({data}) => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    arrows: false, // Hide default navigation buttons
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  const goToPrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  const goToNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const reviews = useMemo(() => {
    if (!Array.isArray(data)) return DEFAULT_REVIEWS;
    const normalized = data
      .map((item, index) => {
        const ratingValue =
          typeof item?.rating === "number"
            ? item.rating
            : Number(item?.rating);
        return {
          id: item?.id || item?._id || index,
          name: item?.name || item?.title || "Anonymous",
          role: item?.role || item?.subtitle || "",
          image:
            item?.image ||
            "https://storage.googleapis.com/road-to-fe/uploads/1741110068604-0bcf572c-2c60-4ba1-99b0-7e9c6bf71d3a-person1.webp",
          rating: Math.max(0, Math.min(5, Number.isFinite(ratingValue) ? ratingValue : 5)),
          review:
            item?.review ||
            item?.content ||
            "Our students consistently praise the clarity of our materials and the support they receive along the way.",
        };
      })
      .filter((item) => item.review);

    return normalized.length ? normalized : DEFAULT_REVIEWS;
  }, [data]);

  return (
    <div className="sm:mt-24 mt-12 pb-12  container mx-auto">
      <div className="gap-6">
        <div className="max-w-full">
          <div className="flex justify-between items-center mb-10">
            <div>
              <h3 className="text-sm uppercase tracking-wider text-gray-700">
                Our Students Review
              </h3>
              <h2 className="text-3xl font-bold mt-2 text-gray-700">
                What our students say about us
              </h2>
            </div>
            <div className="flex space-x-2">
              <button
                onClick={goToPrev}
                className="bg-white/20 hover:bg-primary hover:text-white text-gray-700 rounded-full w-12 h-12 flex items-center justify-center border border-primary border-dashed p-3 duration-300"
              >
                &#10094;
              </button>
              <button
                onClick={goToNext}
                className="bg-white/20 hover:bg-primary hover:text-white text-gray-700 rounded-full w-12 h-12 flex items-center justify-center border border-primary border-dashed p-3 duration-300"
              >
                &#10095;
              </button>
            </div>
          </div>

          <Slider ref={sliderRef} {...settings}>
            {reviews.map((review) => (
              <div key={review.id} className="px-3">
                <div
                  className={`bg-primary text-white rounded-md p-6 text-center relative`}
                >
                  <div className="absolute top-4 right-4 bg-white/20 hover:bg-white/40 text-white rounded-full w-12 h-12 flex items-center justify-center">
                    {review.rating.toFixed(1)}
                  </div>

                  <div className="mb-4 flex justify-center">
                    <img
                      src={review.image}
                      alt={review.name}
                      className="w-20 h-20 rounded-full object-cover border-4 border-gray-100"
                    />
                  </div>
                  <div className="space-y-2">
                    <h3 className="text-lg font-bold">{review.name}</h3>
                    <p className="text-md text-white">{review.role}</p>

                    <p className="text-gray-200 text-sm">{review.review}</p>

                    <div className="flex justify-center">
                      {[...Array(5)].map((_, index) => (
                        <span
                          key={index}
                          className={`text-yellow-400 text-xl ${
                            index < Math.floor(review.rating)
                              ? "opacity-100"
                              : "opacity-30"
                          }`}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ReviewSlider;
